// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero_wrapper__wmfqp","outerwrapper":"hero_outerwrapper__Tsubc","inset":"hero_inset__9nMz8","heading":"hero_heading__ZDwQ2"};